
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21 11c0 5.524-4.478 10-10 10S1 16.524 1 11C1 5.48 5.478 1 11 1s10 4.48 10 10zm-10 2.016a1.855 1.855 0 100 3.71 1.855 1.855 0 000-3.71zM9.239 6.35l.3 5.484a.484.484 0 00.482.457h1.958c.257 0 .469-.2.483-.457l.299-5.484a.484.484 0 00-.483-.51H9.722a.484.484 0 00-.483.51z","fill":"#061D45","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/ic_pendencias.svg